import { Container } from './styled';
export function Content(props) {
    const { children } = props;
    return <Container>{children}</Container>;
}
